import {
  StandardTableCell,
  StandardTableRow
} from '@components/UI-Components/StandardTableUnits/TableUnits'
import { FontTShirtSize } from '@modules/common/models'
import Checkbox from '@material-ui/core/Checkbox'
import Collapse from '@material-ui/core/Collapse'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import findIndex from 'lodash/findIndex'
import map from 'lodash/map'
import React from 'react'
import { MULTI_SELECT_COLUMN_WIDTH, RowTypes, TABLEBODERWIDTH, TableRow } from '../common'
import * as css from './TableView.css'
import { TableViewColumnDefinition } from '../models/TableViewColumnDefinition'
import { TableViewStoreContext } from '../container/StandardTableView'
import { useObserver } from 'mobx-react-lite'

interface ITableBodyRow {
  data: any
  index: number
  style: any
}

const isRecordRow = (node: TableRow) => {
  return node.type === RowTypes.record
}

export const TableBodyRow: React.FunctionComponent<ITableBodyRow> = ({
  data,
  index,
  style
}) => {
  return useObserver(function useHook() {
    const { allowDisabledRowsSelection } = React.useContext(TableViewStoreContext) as any

    const {
      dataToVirtualize,
      showBodyRowBorder,
      rowWidth,
      colDef,
      stickyCols,
      rowHeight,
      expandableSectionHeight,
      expandedRowKey,
      expandedRowComponent,
      tableCellFontSize,
      allowMultiSelect,
      selectedRows,
      onCheckboxClick,
      disabledRows,
      isTableDisabled
    } = data

    const row: TableRow = dataToVirtualize[index]
    const isRecordTableRow = isRecordRow(row)
    const rowIndex = findIndex(selectedRows, { id: row.id })
    const isChecked = rowIndex !== -1
    const isTableRowDisabled = findIndex(disabledRows, { id: row.id }) !== -1

    return (
      <StandardTableRow
        key={row.id}
        style={style}
        width={rowWidth}
        rowInactive={row.isActive === false}
        rowTopBorderWidth={
          (showBodyRowBorder
            ? TABLEBODERWIDTH
            : !isRecordTableRow && index !== 0 && TABLEBODERWIDTH) as number
        }
        borderColor={'var(--background-grey-5)'}
      >
        {allowMultiSelect && isRecordTableRow ? (
          <StandardTableCell
            cellWidth={MULTI_SELECT_COLUMN_WIDTH}
            fontSize={tableCellFontSize ? tableCellFontSize : FontTShirtSize.sm}
            cellPad={'0px 9px 0px 9px'}
            cellHeight={
              isRecordTableRow &&
              row[expandedRowKey] &&
              expandedRowComponent &&
              expandableSectionHeight
                ? rowHeight
                : null
            }
            stickyLeft={0}
            totalBorderHeight={TABLEBODERWIDTH}
          >
            <span className={css.letterRow}>
              {!allowDisabledRowsSelection && isTableRowDisabled ? null : (
                <FormControlLabel
                  key={index}
                  id={'value'}
                  classes={{ root: css.formControlLabel }}
                  control={
                    <Checkbox
                      classes={{ root: css.checkbox }}
                      checked={isChecked}
                      onChange={onCheckboxClick(row)}
                      disabled={isTableRowDisabled || isTableDisabled}
                      color='primary'
                      value={data[index]}
                    />
                  }
                  label={''}
                />
              )}
            </span>
          </StandardTableCell>
        ) : null}
        {map(colDef, (col: TableViewColumnDefinition, colIndex: number) => {
          return (
            <StandardTableCell
              key={row.id + '-' + col.id}
              cellWidth={col.width}
              fontSize={tableCellFontSize ? tableCellFontSize : FontTShirtSize.sm}
              cellPad={col.isRootColumn ? '0px' : '0px 9px 0px 9px'}
              cellHeight={
                isRecordTableRow &&
                row[expandedRowKey] &&
                expandedRowComponent &&
                expandableSectionHeight
                  ? rowHeight
                  : null
              }
              stickyLeft={stickyCols[colIndex] && stickyCols[colIndex].left}
              isCellShadow={
                stickyCols[colIndex] && stickyCols[colIndex].shouldApplyCellShadow
              }
              totalBorderHeight={TABLEBODERWIDTH}
            >
              {isRecordTableRow
                ? col.node.component(row, col)
                : colIndex === 0 && <span className={css.letterRow}>{row.initial}</span>}
            </StandardTableCell>
          )
        })}
        {isRecordTableRow && expandedRowComponent ? (
          <Collapse in={!!row[expandedRowKey]}>
            {row[expandedRowKey]
              ? expandedRowComponent(row, expandableSectionHeight)
              : null}
          </Collapse>
        ) : null}
      </StandardTableRow>
    )
  })
}
